import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Types
import { WheelType } from "../../../types/Wheel";

const { VITE_APP_PROJECT_NAME } = import.meta.env;

type WheelState = {
  attempts: number;
  angle: number;
  idle: boolean;
  disabled: boolean;
  type: WheelType;
};

const initialState: WheelState = {
  attempts: 2,
  angle: 0,
  idle: true,
  disabled: false,
  type: WheelType.INITIAL,
};

export const wheelSlice = createSlice({
  name: "wheel",
  initialState,
  reducers: {
    spin(state) {
      state.disabled = true;
      state.idle = false;
      if (VITE_APP_PROJECT_NAME === "banger") {
        state.angle = state.attempts === 2 ? 715 : 1410;
      }
      if (VITE_APP_PROJECT_NAME === "glory") {
        state.angle = state.attempts === 2 ? 765 : 1440;
      }
    },
    afterSpin(state) {
      if (state.attempts === 2) {
        state.attempts = 1;
        state.idle = true;
        // show modal win
      } else {
        state.attempts = 0;
        // show modal registration
      }
      state.disabled = false;
    },
    setType(state, action: PayloadAction<WheelType>) {
      state.type = action.payload;
    },
  },
});

export const { spin, afterSpin, setType } = wheelSlice.actions;

export default wheelSlice.reducer;
